module.exports = __webpack_public_path__ + "static/media/chevron-open.6a3a1b55.svg";